import { Layout } from "@mcleod/components";

export abstract class AutogenLayoutEdiOrderProfileLookup extends Layout {
}
